export const TABLE_KEY = Object.freeze({
  EXERCISES: 'exercises',
  LESSONS: 'lessons',
  COURSES: 'courses',
  INSTITUTIONS: 'institutions',
  TRAINER_FULL_TIME: 'trainer_full_time',
  LEARNERS: 'learners',
  CLASSES: 'classes',
  FUNCTIONAL_TEST: 'functional_test',
  ASSESSMENTS: 'assessments',
  LEARNER_CLASS_RESULT: 'learner_class_result',
  ADMINS: 'admins',
});
